var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.286,
    height: 18.017,
    fill: "none",
    viewBox: "0 0 14.286 18.017",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.4761 0 0 1.4761 .63346 .63099)",
    d: "m4.4102 0.25c-1.0653 0-2.1306 0.40597-2.9434 1.2188-0.73672 0.73672-1.14 1.681-1.209 2.6445-0.050074 0.78688 0.09656 1.489 0.39258 2.1094 0.42187 0.88411 1.0504 1.3644 1.8457 1.7695 1.4321 0.72957 1.9021 2.0747 1.9141 3.1133 0.011964-1.0385 0.48196-2.3837 1.9141-3.1133 0.79529-0.40515 1.4238-0.88542 1.8457-1.7695 0.29602-0.62035 0.44265-1.3225 0.39258-2.1094-0.068957-0.96356-0.47226-1.9078-1.209-2.6445-0.8128-0.81278-1.8781-1.2188-2.9434-1.2188zm0 2.3164c1.0198 0 1.8457 0.82601 1.8457 1.8457 0 1.0198-0.82591 1.8477-1.8457 1.8477-1.0198 0-1.8457-0.82786-1.8457-1.8477 0-1.0197 0.82591-1.8457 1.8457-1.8457z",
    clipPath: "url(#clipPath10831)",
    style: {
      fill: "#38aeff",
      paintOrder: "stroke markers fill",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.355,
      stroke: "#104585"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath10831"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.99728,
    y: -1.2538,
    width: 10.817,
    height: 13.057,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPin);
export default __webpack_public_path__ + "static/media/icon_pin.32e2f090224af0a02756cb12d03f8152.svg";
export { ForwardRef as ReactComponent };